// extracted by mini-css-extract-plugin
export default {"wrapper":"Time_wrapper__ppoBb","small":"Time_small__0-dk8"};